import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import CodeMatchSnippet from "../match/CodeMatchSnippet";
import { TagMatchDto } from "../common/dto/TagMatchDto";
import { BlockMatchSnippetDto } from "../common/dto/BlockMatchSnippetDto";
import { Link } from "react-router-dom";

type State = {
    tagMatchDto: TagMatchDto | null
    snippet1: BlockMatchSnippetDto | null
    snippet2: BlockMatchSnippetDto | null
    userIndex: number,
    blockCount: number,
    blockIndex: number,
    currentSnippet: BlockMatchSnippetDto | null
    currentHash: string | null
}

type Props = {
    tagMatchId: string
}

export default class TagMatchPage extends Component<ServiceCollectionParam & Props, {}> {

    state: State = {
        tagMatchDto: null,
        snippet1: null,
        snippet2: null,
        userIndex: 0,
        blockCount: 0,
        blockIndex: 0,
        currentSnippet: null,
        currentHash: null
    }

    async componentDidMount() {
        await this.refresh();
    }

    async refresh() {
        const tagMatchId = this.props.tagMatchId;

        this.state.tagMatchDto = await this.props.services.dao.findTagMatchById(tagMatchId);

        this.state.blockCount = this.state.tagMatchDto.matchedBlocks.length;

        if (this.state.blockCount === 0) {
            return;
        }

        const index = this.state.blockIndex;

        this.state.currentHash = this.state.tagMatchDto.matchedBlocks[index].hash;

        const [snippet1, snippet2] = await Promise.all([
            await this.props.services.dao.findCodeMatchSnippet(tagMatchId, index, 0),
            await this.props.services.dao.findCodeMatchSnippet(tagMatchId, index, 1)
        ]);

        this.state.snippet1 = snippet1;
        this.state.snippet2 = snippet2;
        this.state.currentSnippet = snippet1;

        this.setState(this.state);
    }

    async switchUser() {
        if (!this.state.snippet1 || !this.state.snippet2) {
            return;
        }

        this.state.userIndex = ++this.state.userIndex % 2;

        this.state.currentSnippet = this.state.userIndex === 0
            ? this.state.snippet1
            : this.state.snippet2

        this.setState(this.state);
    }

    async nextBlock() {
        this.state.blockIndex = (this.state.blockIndex + 1) % this.state.blockCount;

        this.setState(this.state);

        await this.refresh();
    }

    async previousBlock() {
        this.state.blockIndex = this.state.blockIndex - 1;

        if (this.state.blockIndex < 0) {
            this.state.blockIndex = this.state.blockCount - 1;
        }

        this.setState(this.state);

        await this.refresh();
    }

    async markAsProblem() {
        const tagMatchId = this.props.tagMatchId;

        await this.props.services.dao.markCodeMatchAsProblem(tagMatchId);
    }

    async markAsCommon() {
        const hash = this.state.currentHash;

        if (hash === null) {
            return;
        }

        await this.props.services.dao.markCodeMatchAsCommon(hash);

        await this.refreshBlockPosition();
    }

    async markFileAsIgnored() {
        const path = this.state.snippet1?.filePath;

        if (path === undefined) {
            return;
        }

        await this.props.services.dao.markCodeMatchFileAsIgnored(path);

        await this.refreshBlockPosition();
    }

    async refreshBlockPosition() {
        this.state.blockIndex = 0;

        this.setState(this.state);

        await this.refresh();
    }

    render() {
        if (this.state.blockCount === 0) {
            return <div>Kattuvaid plokke pole!</div>;
        }

        if (!this.state.snippet1
            || !this.state.snippet2
            || !this.state.currentSnippet) {
            return <div>Viga!</div>;
        }

        const first = this.state.snippet1;
        const second = this.state.snippet2;

        return (
            <>
                <div className="d-flex justify-content-between">
                    <div><Link to={'/tag-matches'}>Tagasi</Link></div>
                    <div>
                        <button onClick={ () => this.markAsProblem() }
                                className="px-4 btn btn-danger">Probleem!</button>
                    </div>
                    <div>
                        <button onClick={ () => this.markFileAsIgnored() }
                                className="px-4 btn btn-warning">Üldine fail!</button>
                    </div>
                    <div>
                        <button onClick={ () => this.markAsCommon() }
                                className="px-4 btn btn-warning">Üldine kood!</button>
                    </div>
                    <div>
                        { this.state.blockIndex + 1 } / { this.state.blockCount }

                        <button onClick={ () => this.previousBlock() }
                            className="mx-2 px-4 btn btn-secondary">&lt;</button>

                        <button onClick={ () => this.nextBlock() }
                            className="px-4 btn btn-secondary">&gt;</button>
                    </div>
                </div>

                <div className="pt-3" onClick={ () => this.switchUser() } >
                    { first.filePath }
                    <span className={'fw-bold'}>
                        { this.state.userIndex === 0 ? <> &lt;&lt;&lt; </> : <> &gt;&gt;&gt; </> }
                    </span>
                    { second.filePath }
                </div>

                <CodeMatchSnippet key={Math.random()} snippet={ this.state.currentSnippet } />

            </>);
    }

}

